import styles from "./Player.module.css";
import { FaSignal } from "react-icons/fa";
import PlayerAvatar from "./PlayerAvatar";

function Player({
  elo,
  previousElo,
  displayName,
  gameEnded,
  avatarId,
  fbId,
  isUser,
  isGuest,
  id,
  avatarType,
  children,
}) {
  function renderElo() {
    if (!elo) {
      return;
    }
    if (previousElo) {
      const diff = elo - previousElo;
      let diffTag;

      if (diff > 0) {
        diffTag = <span className={styles.diffEqual}>+{diff}</span>;
      } else if (diff < 0) {
        diffTag = <span className={styles.diffEqual}>{diff}</span>;
      } else {
        diffTag = <span className={styles.diffEqual}>0</span>;
      }

      return (
        <div className="inline-flex font-normal ">
          <div className="pr-1 text-base">
            <FaSignal />
          </div>
          {elo} ({diffTag})
        </div>
      );
    } else {
      return (
        <div className="inline-flex font-normal">
          <div className="pr-1 text-base">
            <FaSignal />
          </div>
          {elo}
        </div>
      );
    }
  }

  const usernameStyle = gameEnded ? styles.usernameGameEnded : styles.username;

  return (
    <div className={styles.player}>
      <div className={`font-semibold bg-gray-200 ${styles.header}`}>
        <div className={usernameStyle}>{displayName}</div>
        {renderElo()}
      </div>
      <div className={styles.body}>
        <PlayerAvatar
          {...{ isUser, avatarId, fbId, isGuest, id, avatarType, gameEnded }}
        />
        {children}
      </div>
    </div>
  );
}

export default Player;
